import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  auth: {
    isLoggedIn: false,
    pending: false,
    token: null,
    username: null,
    // instcode: null,
    loading: false
  },
  CurrPaper: 0,
  PaperList: [],
  SubmitExam: false,
  LoadDialog: false,
  ShowFooter: true
}

const getters = {
  isLoggedIn: state => state.auth.isLoggedIn,
  getToken: state => state.auth.token,
  getUsername: state => state.auth.username,
  // getInstcode: state => state.auth.instcode,
  getloading: state => state.auth.loading,
  getCurrentPaper: state => state.CurrPaper,
  getPaperList: state => state.PaperList,
  getSubmitExam: state => state.SubmitExam,
  getLoadDialog: state => state.LoadDialog,
  getShowFooter: state => state.ShowFooter
}

const mutations = {
  userLogin (state) {
    state.auth.pending = true
  },
  onSpinner (state) {
    state.auth.loading = true
  },
  offSpinner (state) {
    state.auth.loading = false
  },
  setCurrentPaper (state, data) {
    state.CurrPaper = data.CurrentPaper
  },
  setPaperList (state, data) {
    state.PaperList = data.Papers
  },
  setSubmitExam (state, data) {
    state.SubmitExam = data.SubmitSetter
  },
  setLoadDialog (state, data) {
    state.LoadDialog = data.DialogLoad
  },
  setShowFooter (state, data) {
    state.ShowFooter = data.shwfooter
  },
  successFulLogin (state, data) {
    const token = data.token
    const username = data.username
    // const instcode = data.instcode
    state.auth.isLoggedIn = true
    state.auth.pending = false
    state.auth.token = token
    state.auth.username = username
    // state.auth.instcode = instcode
    localStorage.setItem('JWT', token)
    localStorage.setItem('username', username)
    // localStorage.setItem('instcode', instcode)
    // console.log('data: ', state.auth.token)
  },
  loginWrongCredentials (state) {
    state.auth.pending = false
    state.auth.isLoggedIn = false
  },
  loginError (state) {
    state.auth.pending = false
    state.auth.isLoggedIn = false
  },
  userLogout (state) {
    localStorage.removeItem('JWT')
    localStorage.removeItem('username')
    // localStorage.removeItem('instcode')
    state.auth.isLoggedIn = false
  }
}

const options = {
  state,
  mutations,
  getters
}

const store = new Vuex.Store(options)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js